(() => {

	const profileToggle = document.getElementById('toggleEditProfileBlock');

	if(profileToggle) {
		profileToggle.addEventListener('click', () => {
			toggleEditBlock();
		});

		const toggleEditBlock = () => {
			const editProfileBlock = document.querySelector('.edit_profile');
			if(editProfileBlock) {
				if(editProfileBlock.classList.contains('hidden')) {
					editProfileBlock.classList.remove('hidden');
				} else {
					editProfileBlock.classList.add('hidden');
				}
			}
		};
	}
})();
